import React from "react";

const PastScore = ({ image, name, score }) => {
  return (
    <div className="flex flex-col justify-end items-center rounded-medium gap-2 p-2 w-40 border border-white">
      <img
        src={image}
        alt={"image of " + name}
        className="rounded-medium w-2/3"
      />
      <h3>{name}</h3>
      <p>
        Score: <span className="text-success-500">{score}</span>
      </p>
    </div>
  );
};

export default PastScore;
